<template>
  <div v-if="impianto" class="impianto">
    <div @click="playVideo" id="impiantoVideoWrapp" class="video-header" ref="video">
      <video id="impiantoVideo" class="inner setResolution autoplay" preload="metadata" autoplay muted="muted" loop playsinline  is-playing="false" data-object-fit="cover" hasaudio="false" style="width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; background-color: #000; left: 0; top: 0;">
        <source :src="impianto.videoHd " type="video/mp4">
        <source :src="impianto.video720 " media="all and (max-width:1280px)" type="video/mp4">
        <source :src="impianto.video540 " media="all and (max-width:960px)" type="video/mp4">
        <source :src="impianto.video360 " media="all and (max-width:640px)" type="video/mp4">
      </video>
      <div
        class="home-scroll-invite"
        @click="$_scrollBottom">
        <span>{{ $t('scorri') }}</span>
        <div class="v-line"></div>
      </div>
    </div>
    <section v-if="impianto" class="padding-paragrafo padding-paragrafo--less-bottom lavorazioni-content-area">
      <div class="default-container">
        <h3 v-html="impianto.titleGallery" />
        <div v-html="impianto.textGallery" />
      </div>
    </section>
     <section v-if="impianto && impianto.gallery && impianto.gallery.length > 0" class="lavorazioni-sub-tech-details">
      <ecogas-gallery :gallery="impianto.gallery" :lang="lang"/>
    </section>
    <section class="padding-paragrafo padding-paragrafo--less lavorazioni-content-area">
      <div class="default-container">
        <div>
          <h2 class="text-to-uppercase">{{impianto.introArchitecture}}</h2>
          <h3 v-if="impianto && impianto.titoloArchitecture" v-html="impianto.titoloArchitecture.replace(/\n/g, '<br> ')"/>
        </div>
        <div>
          <div class="double-column" v-html="impianto.textArchitecture" />
        </div>
      </div>
    </section>
    <section class="padding-paragrafo padding-paragrafo--less-top">
      <div class="default-container">
        <div v-if="impianto.imageDesk " class="img-container">
          <picture>
            <source :srcset="impianto.imageDesk.responsiveImage.src" media="(min-width: 1000px)">
            <img :src="impianto.imageMobile ? impianto.imageMobile.responsiveImage.src : impianto.imageDesk.responsiveImage.src" :alt="impianto.introArchitecture">
          </picture>
         <!-- <Brochure
            :to="{ name: `${lang}-richiesta-brochure`, params: { lang } }"
            :label="$t('brochureTecnica')"
            class="hide-to-mobile"
          />-->
        </div>
        <ul v-if="impianto.fasiList && impianto.fasiList.length > 0" class="sectionsComeFunziona">
          <li
            v-for="(section, index) of impianto.fasiList"
            :key="index" class="text-to-uppercase">
              {{ section.titolo }}
          </li>
        </ul>
       <!-- <Brochure
            :to="{ name: `${lang}-richiesta-brochure`, params: { lang } }"
            :label="$t('brochureTecnica')"
            class="hide-to-desk"
          />-->
      </div>
    </section>
    <section v-if="(impianto.backgroundImageDesk) || impianto.backgroundImageMobile"
      :style="viewport.label === 'mobile' && impianto.backgroundImageMobile ? `background-color: #343434; background-image: url('${impianto.backgroundImageMobile.responsiveImage.src}'); background-position: bottom center; background-size: cover;` : `background-color: #343434; background-image: url('${impianto.backgroundImageDesk.responsiveImage.src}'); background-position: bottom center; background-size: cover;`"
      class="padding-paragrafo paragrafo-h-p font-white background-area">
      <div
        v-animate-on-intersection
        class="default-container">
        <h3 v-if="impianto && impianto.titleDark" v-html="impianto.titleDark.replace(/\n/g, '<br> ')" />
        <div v-if="impianto && impianto.statsBlock && impianto.statsBlock.length > 0" class="contentMiddle" >
          <ul>
            <li v-for="(block, index) in impianto.statsBlock" :key="index">
              {{block.number}}<sup>{{block.unit}}</sup> <p v-if="block && block.description !== ''" v-html="block.description.replace(/\n/g, '<br> ')"/>
            </li>
          </ul>
          <p v-if="impianto && impianto.captionStats" v-html="impianto.captionStats.replace(/\n/g, '<br>')" class="text-no-uppercase"/>
          </div>
        <div v-if="impianto.titlePayback !== ''" class="payback text-to-uppercase" >
          <p>{{impianto.titlePayback}}</p><span>{{impianto.subtitlePayback}}</span>
        </div>
        <div>
          <h4 v-if="impianto && impianto.titleBottomSectionDark" v-html="impianto.titleBottomSectionDark.replace(/\n/g, '<br> ')" />
          <div class="double-column" v-html="impianto.textBottomSectionDark" />
        </div>
      </div>
    </section>
    <section class="padding-paragrafo paragrafo-h-p font-black less-text-width smaltimento">
      <div
        v-animate-on-intersection
        class="default-container">
        <div>
          <h3 v-html="impianto.introTable" class="text-to-uppercase"/>
          <div v-html="impianto.textTable"/>
        </div>
        <TableSmaltimento v-if="impianto && impianto.table" :table="impianto.table"/>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import EcogasGallery from '@/components/EcogasGallery'
import Brochure from '@/components/Brochure'
import TableSmaltimento from '@/components/TableSmaltimento'
import { impiantoPage } from '@/queries/impianto.js'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    EcogasGallery,
    Brochure,
    TableSmaltimento
  },
  data: () => ({
    impianto: {},
    seo: {}
  }),
  apollo: {
    impianto: {
      query: impiantoPage,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.impianto = result.data.impianto
          this.seo = this.impianto.seo
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'viewport'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    bgImage: {
      get () {
        return `${this.imgServer}${this.pageApiData.cover[this.viewport.label]}`
      }
    },
    getBackgroundCss: {
      get () {
        return `background-color: #343434; background-image: url('${this.bgImage}'); background-position: bottom center; background-size: cover;`
      }
    }
  },
  mounted () {
    setTimeout(() => {
      const video = document.getElementById('impiantoVideo')
      if (video) {
      // console.log(video)
      // video.play()
        document.getElementById('impiantoVideoWrapp').click()
      }
    }, 900)
  },
  methods: {
    $_scrollBottom () {
      window.scroll({ top: this.$refs.video.offsetHeight, left: 0, behavior: 'smooth' })
    },
    playVideo () {
      // console.log('sto cliccando')
      const video = document.getElementById('impiantoVideo')
      // console.log(video.play())
      // video.pause()
      video.load()
      video.play()
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .impianto {
    .lavorazioni-content-area, .lavorazioni-sub-tech-details{
      background-color: #F8F8F8;
    }
    .img-container{
      picture {
        height: auto;
        width: 100%;
        display: block;
        img {
          width: 100%;
          height: auto;
          margin: 0;
        }
      }
      a{
        //display: inline-block;
        position: absolute;
        right: 0;
        bottom: 4px;
      }
    }
    .sectionsComeFunziona{
      margin-top: 45px;
      @media #{$medium_mq} {
        margin-top: 50px;
      }
      @media #{$large_mq} {
        margin-top: 55px;
      }
      @media #{$xlarge_mq} {
        margin-top: 60px;
      }
      list-style: decimal;
      li {
        font-size: .9rem;
        color: #1D1D1B;
        font-family: 'IBM Plex Mono', sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        list-style: decimal;
        list-style-position: inside;
        padding: 3px 0;
        @media #{$medium_mq} {
          font-size: .95rem;
        }
        @media #{$large_mq} {
          font-size: 1.05rem;
        }
        @media #{$xlarge_mq} {
          font-size: 1.15rem;
        }
        @media #{$xxlarge_mq} {
          font-size: 1.25rem;
        }
      }
    }
    .paragrafo-h-p.font-white.background-area{
      h3, h4 {
        @include section-paragraph(#FFF);
        margin: 0 0 60px;
        @media #{$large_mq} {
          margin: 0 0 80px;
        }
        @media #{$xlarge_mq} {
          margin: 0 0 100px;
        }
      }
      p {
        @include hero-small-p(#FFF);
      }
      .double-column{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        p {
          width: 90%;
        }
        @media #{$large_mq} {
          flex-wrap: nowrap;
          p {
            width: 45%;
          }
        }
      }
      .contentMiddle{
        ul {
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 60px;
          @media #{$large_mq} {
            margin: 0 0 80px;
          }
          @media #{$xlarge_mq} {
            margin: 0 0 110px;
          }
          li {
            padding: 0;
            width: 100%;
            @media #{$large_mq} {
              width: 50%;
            }
            &:before{
              content: none;
            }
            font-size: 90px;
            color: #30AE8D;
            font-family: 'IBM Plex Mono', sans-serif;
            font-weight: 400;

            font-size: 3.5rem;
            @media #{$large_mq} {
                font-size: 4.25rem;
            }
            @media #{$xlarge_mq} {
                font-size: 5.625rem;
            }

            sup {
              font-size: .3em;
              top: -1.5em;
              padding-left: 30px;

            }
            p{
              text-transform: uppercase;
              letter-spacing: .05rem;
              margin-bottom: 0;
              font-size: 1.1rem;
              @media #{$large_mq} {
                  font-size: 1.35rem;
              }
              @media #{$xlarge_mq} {
                  font-size: 1.5rem;
              }

            }
          }
        }
        p{
          font-size: .9rem;
          color: #FFF;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          text-transform: uppercase;
          letter-spacing: .05rem;
          @media #{$large_mq} {
              font-size: 1.05rem;
          }
          @media #{$xlarge_mq} {
              font-size: 1.125rem;
          }
          margin: 0 0 60px;
          @media #{$large_mq} {
            margin: 0 0 80px;
          }
          @media #{$xlarge_mq} {
            margin: 0 0 110px;
          }
        }
      }
      .payback{
        position: relative;
        display: inline-block;
        outline: 0;
        text-align: left;
        text-decoration: none;
        padding: 40px 30px;
        margin: 0 0 90px;
        @media #{$large_mq} {
          padding: 60px 52px;
          margin: 0 0 110px;
        }
        @media #{$xlarge_mq} {
          padding: 80px 74px;
          margin: 0 0 138px;
        }

        background: transparent linear-gradient(74deg, #30AE8D 0%, #5DE067 100%) 0% 0% no-repeat padding-box;
        p {
          color: #FFF;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          font-size: 3.5rem;
          @media #{$large_mq} {
              font-size: 4.25rem;
          }
          @media #{$xlarge_mq} {
              font-size: 5.625rem;
          }
          margin: 0 0 20px;
        }
        span {
          display: block;
          color: #FFF;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          font-size: 1.1rem;
          @media #{$large_mq} {
              font-size: 1.25rem;
          }
          @media #{$xlarge_mq} {
              font-size: 1.3125rem;
          }
        }
      }
    }
    .paragrafo-h-p.font-black.smaltimento{
      p {
        font-size: 1.3rem;
        line-height: 1.3;
        font-family: 'IBM Plex Sans Condensed', sans-serif;
        font-weight: 300;
        color: #343434;
        @media #{$medium_mq} {
          font-size: 1.65rem;
        }
        @media #{$large_mq} {
          font-size: 2rem;
        }
        @media #{$xlarge_mq} {
          font-size: 2.5rem;
        }
        @media #{$xxlarge_mq} {
          font-size: 2.8125rem;
        }
      }
    }
  }

</style>
